module.exports = __webpack_public_path__ + "static/media/Renewal&Modification.adf23601.jpg";